import React from 'react';

const Deal = () => {
    return (
        <section className="deals-style-two sec-pad deal-custom centred">
            <div className="auto-container">
                <div className="sec-title">
                    <h2 style={{ marginBottom: "20px" }}>Property Search</h2>
                    <p style={{ fontSize: "18px", fontWeight: "500", color: "#333", marginBottom: "30px" }}>
                        (Contact Manav Seth for your property search)
                    </p>
                    <div className="btn-box mt-4">
                        <a href="/contact" className="theme-btn btn-one">
                            Contact Us
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Deal;
